// extracted by mini-css-extract-plugin
export default {"embedGallery":"GalleryEmbed_embedGallery__RvqRw"};